export const EnvSetting = {
    production: false,
    colorCode: '',
    LANGUAGE_CONFIG: {
        defaultLanguage: '',
        defaultLanguageText: '',
        defaultLanguageFlag: '',
    },
    language: {
        LanguageOverRule: false,
        LanguageOverRuleDefault: ''
    },
    NOTIFICATION_API_BASE_URL: '',
    LOCALIZATION_API_BASE_URL: '',
    SMS_API_BASE_URL: '',
    ADMIN_BASE_API_URL: '',
    CAMPAIGN_BASE_API_URL: '',
    WIDGET_API_URI: '',
    CHECKIN_BASE_API_URL: '',
    STATUS_TRACKER_BASE_API_URL: '',
    googleMapUrl: '',
    googleKey: '',
    STATUSTRACKER_DEFAULT_LANGUAGE_CONFIG: '',
    CHECKIN_DEFAULT_LANGUAGE_CONFIG: '',
    GOOGLE_API_KEY: '',
    otpExpireTime: '',
    currentenvironment: '',
    vehicleOwnerSource: '',
    CultureFormat: '',
    parts_service_url: '',
    PUSH_NOTIFICATION_API_URI: '',
    ShiftTime: '',
    MinimunTimeSlot: '',
    FuturePlanningTime: '',
    EnableCookieConsent: false,
    Tracker_CookieScript_Key: '',
    Widget_CookieScript_Key: '',
    CheckIn_CookieScript_Key: '',
    IsActiveTodayBooking: '',
    Country: '',
    ThirdPartyVehicleSource: '',
    WidgetContacUsLink: "",
    StatusTrackerInterval: '',
    SlotExpireMinutes: '',
    WhatsAppNotificationRefreshInterval: '',
    whatsappContactNo: '',
    VIEW_IMAGE_API_URL: '',
    BRAND_API_URL: '',
    PlanningFromTime: '',
    PlanningToTime: ''
}
export function ClientAppToken(){
    return localStorage.getItem('access_token');
}
export function ClientAppLogin(token){
    localStorage.removeItem('access_token');
    localStorage.setItem('access_token', token);
}
export function ClientAppLogout(){
    localStorage.removeItem('access_token');
    EnvSetting.colorCode = '';
}